import { render, staticRenderFns } from "./shoppingguidenotification_editor.vue?vue&type=template&id=59945532&scoped=true"
import script from "./shoppingguidenotification_editor.vue?vue&type=script&lang=js"
export * from "./shoppingguidenotification_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59945532",
  null
  
)

export default component.exports